export interface ClearSiteDataDeps {
  serviceWorker: ServiceWorkerContainer | undefined;
  caches: CacheStorage;
}

export async function clearSiteData(deps: ClearSiteDataDeps): Promise<void> {
  const { serviceWorker } = deps;
  if (serviceWorker === undefined) {
    return;
  }

  try {
    // Wait for the service worker to be ready, but don't wait more than 3 seconds.
    await new Promise<void>((resolve) => {
      serviceWorker.ready.then(() => resolve()).catch(() => resolve());
      setTimeout(() => resolve(), 3000);
    });
    const registrations = await serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
  } catch (error) {
    console.warn(
      '[site-data-reset] failed to unregister service workers',
      error
    );
  }

  try {
    const keys = (await deps.caches.keys()).filter((key) =>
      key.startsWith('ngsw:')
    );
    await Promise.all(keys.map((key) => deps.caches!.delete(key)));
  } catch (error) {
    console.warn('[site-data-reset] failed to clear cache storage', error);
  }
}
